import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import './BudgetChart.css';

const BudgetChart = ({ incomeTotal, expenseTotal, viewMode }) => {
  const incomeBarRef = useRef(null);
  const expenseBarRef = useRef(null);
  const incomeValueRef = useRef(null);
  const expenseValueRef = useRef(null);
  
  // 余剰または不足の計算
  const balance = incomeTotal - expenseTotal;
  const isPositive = balance >= 0;
  
  // GSAPアニメーション
  useEffect(() => {
    // バーのアニメーション
    const maxValue = Math.max(incomeTotal, expenseTotal);
    const incomePercent = maxValue > 0 ? (incomeTotal / maxValue) * 100 : 0;
    const expensePercent = maxValue > 0 ? (expenseTotal / maxValue) * 100 : 0;
    
    // 収入バーのアニメーション
    gsap.to(incomeBarRef.current, {
      width: `${incomePercent}%`,
      duration: 1,
      ease: 'power2.out'
    });
    
    // 支出バーのアニメーション
    gsap.to(expenseBarRef.current, {
      width: `${expensePercent}%`,
      duration: 1,
      ease: 'power2.out'
    });
    
    // 金額のカウントアップアニメーション
    gsap.to(incomeValueRef.current, {
      innerText: Math.round(incomeTotal),
      duration: 1,
      ease: 'power2.out',
      snap: { innerText: 1 },
      onUpdate: function() {
        incomeValueRef.current.innerText = parseInt(incomeValueRef.current.innerText).toLocaleString();
      }
    });
    
    gsap.to(expenseValueRef.current, {
      innerText: Math.round(expenseTotal),
      duration: 1,
      ease: 'power2.out',
      snap: { innerText: 1 },
      onUpdate: function() {
        expenseValueRef.current.innerText = parseInt(expenseValueRef.current.innerText).toLocaleString();
      }
    });
  }, [incomeTotal, expenseTotal]);
  
  return (
    <div className="budget-chart">
      <div className="chart-header">
        <h3>{viewMode === 'monthly' ? '月間' : '年間'}収支グラフ</h3>
      </div>
      
      <div className="chart-container">
        <div className="chart-item">
          <div className="chart-label">収入</div>
          <div className="chart-bar-container">
            <div 
              ref={incomeBarRef} 
              className="chart-bar income-bar"
            ></div>
          </div>
          <div className="chart-value">
            <span className="currency-symbol">¥</span>
            <span ref={incomeValueRef} className="amount-value">0</span>
          </div>
        </div>
        
        <div className="chart-item">
          <div className="chart-label">支出</div>
          <div className="chart-bar-container">
            <div 
              ref={expenseBarRef} 
              className="chart-bar expense-bar"
            ></div>
          </div>
          <div className="chart-value">
            <span className="currency-symbol">¥</span>
            <span ref={expenseValueRef} className="amount-value">0</span>
          </div>
        </div>
      </div>
      
      <div className={`chart-balance ${isPositive ? 'positive' : 'negative'}`}>
        <div className="balance-label">
          {isPositive ? '余剰:' : '不足:'}
        </div>
        <div className="balance-value">
          <span className="currency-symbol">¥</span>
          <span className="amount-value">{Math.abs(balance).toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
};

export default BudgetChart; 